import { ErrorModel } from '@era/app';
import { createActionGroup, props } from '@ngrx/store';
import { AppleAirPlaySecurityPreset } from '@rocksoft/mdm-sdk-v2';
import { CategoryType } from '../shared/types';
import { CategoryAirplaySecurityProfileConfiguration } from './category-airplay-security-profile.state';

// ============================================================================
// RESOLVER ACTIONS
// ============================================================================

export const CategoryAirplaySecurityProfileResolverActions = createActionGroup({
  source: 'Category AirplaySecurity Profile Resolver',
  events: {
    'Category Profile Requested': props<{ id: string; categoryType: CategoryType }>(),
  },
});

// ============================================================================
// API ACTIONS
// ============================================================================

export const CategoryAirplaySecurityProfileApiActions = createActionGroup({
  source: 'Category AirplaySecurity Profile API',
  events: {
    'Category Profile Loaded': props<{
      configuration: CategoryAirplaySecurityProfileConfiguration;
      categoryType: CategoryType;
    }>(),
    'Category Profile Loaded Error': props<{ error: ErrorModel }>(),
    'Category Profile Added': props<{
      configuration: CategoryAirplaySecurityProfileConfiguration;
      categoryType: CategoryType;
    }>(),
    'Category Profile Added Error': props<{
      configuration: CategoryAirplaySecurityProfileConfiguration;
      categoryType: CategoryType;
      error: ErrorModel;
    }>(),
    'Category Profile Updated': props<{
      configuration: CategoryAirplaySecurityProfileConfiguration;
      categoryType: CategoryType;
    }>(),
    'Category Profile Updated Error': props<{
      configuration: CategoryAirplaySecurityProfileConfiguration;
      categoryType: CategoryType;
      error: ErrorModel;
    }>(),
    'Category Profile Deleted': props<{
      configuration: CategoryAirplaySecurityProfileConfiguration;
      categoryType: CategoryType;
    }>(),
    'Category Profile Deleted Error': props<{
      configuration: CategoryAirplaySecurityProfileConfiguration;
      categoryType: CategoryType;
      error: ErrorModel;
    }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const CategoryAirplaySecurityProfileViewActions = createActionGroup({
  source: 'Category AirplaySecurity Profile View',
  events: {
    'Profile Selected': props<{
      categoryType: CategoryType;
      categoryId: string;
      preset: AppleAirPlaySecurityPreset;
      restrict: boolean;
    }>(),
    'Profile Deselected': props<{
      categoryType: CategoryType;
      categoryId: string;
    }>(),
  },
});
